
export const getStatusText = ({ status, paymentStatus }) => {
    let statusInfo = { text: '', color: '' };

    if (paymentStatus) {
        if (status === 'completed') {
            if (paymentStatus === 'pending') {
                statusInfo.text = 'proceedToPay';
                statusInfo.color = '';
            } else if (paymentStatus === 'completed') {
                statusInfo.text = 'completed';
                statusInfo.color = '#03A83B';
            }
        }
    }
    if (!statusInfo.text) {
        const statusMap = {
            completed: { text: 'completed', color: '#03A83B' },
            declined: { text: 'decline', color: '#FE2431' },
            cancelledByUser: { text: 'cancelledByUser', color: '#FE2431' },
            cancelledByPartner: { text: 'cancelledByPartner', color: '#FE2431' },
            scheduled: { text: 'scheduled', color: '#03A83B' },
            expired: { text: 'expired', color: '#F96D08' }
        };
        const mappedStatus = statusMap[status];

        if (mappedStatus) {
            statusInfo.text = mappedStatus.text;
            statusInfo.color = mappedStatus.color;
        }
    }

    return statusInfo;
};